import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { components } from '@atlaskit/react-select/components';

const boxStyles = xcss({
	borderRadius: 'radius.small',
	boxSizing: 'border-box',
});

export const Control = (props: any): React.JSX.Element => (
	<>
		{props.selectProps.isSearchable && (
			<Box paddingInline="space.100" paddingBlockStart="space.100" xcss={boxStyles}>
				<components.Control {...props} />
			</Box>
		)}
	</>
);
